import { useSelector } from 'react-redux'
import { selectSelector } from '../../../redux/slices/select'
import { setDayTypeId, setRouteId, tranRoutesSelector } from '../../../redux/slices/tranRoutes'
import SelectField from '../../reusable/Fields/SelectField'

const SelectFilter = () => {
  const { route_id, day_type_id } = useSelector(tranRoutesSelector)
  const { routes, dayTypes } = useSelector(selectSelector)

  // const dispatch = useDispatch()
  // useEffect(() => {
  //   dispatch(setRouteId(routes[0].route_id))
  // }, [dispatch])

  return (
    <div className="select_filter">
      <SelectField
        standalone
        name="route_id"
        label="Маршрут"
        placeholder="Оберіть Маршрут"
        value={route_id}
        setter={setRouteId}
        options={routes}
        optionsKeys={{ valueKey: 'route_id', labelKey: 'number' }}
      />
      <SelectField
        standalone
        name="day_type_id"
        label="Розклад"
        placeholder="Оберіть Розклад"
        value={day_type_id}
        setter={setDayTypeId}
        options={dayTypes}
        optionsKeys={{ valueKey: 'type_id', labelKey: 'name_uk' }}
      />
    </div>
  )
}

export default SelectFilter
